module.exports = __webpack_public_path__ + "img/LEAF-U.393900a0.svg";